/**
 * RequireDpGlobalAdmin — platform super-admin gate for DecisionPoint global-admin tools.
 * Stays inside the DP shell (no bounce to FusionMSI /dashboard).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import Loading from 'components/Loading';
import DpGlobalAdminRequired from './DpGlobalAdminRequired';
import { authPath } from '../marketing/fusionMsiMarketingRouting';

export default function RequireDpGlobalAdmin({ children }) {
  const { user, userLoading, isGlobalAdmin } = useAuth();
  const location = useLocation();

  if (userLoading) return <Loading page />;

  if (!user || user.isAnonymous) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={authPath({ next })} replace />;
  }

  if (!isGlobalAdmin) {
    return <DpGlobalAdminRequired />;
  }

  return children;
}

RequireDpGlobalAdmin.propTypes = {
  children: PropTypes.node,
};
